import { AbstractStorage } from './abstractStorage';
import { LocalStorage } from './localStorage';

export const getCache = <T>(type = 'localeStorage'): AbstractStorage<T> => {
  switch (type) {
    case 'localStorage':
      return new LocalStorage<T>();

    default:
      throw Error('no storage engine found');
  }
};
